export default __webpack_public_path__ + "static/media/operation.ead534aa.svg";